import { createSlice } from '@reduxjs/toolkit'
import LoadingStatus from 'state/enums/LoadingStatus'

import { sessionEnded } from '../user/actions/endUserSession'
import { loadStats } from './actions'
import ParseDashboard from './parsers/ParseDashboard'
import { DashboardData } from './types'

export interface DashboardState {
    hasDashboard: boolean
    dashboardData: DashboardData
    status: LoadingStatus
    activeRequestId?: string
}

const initialState = {
    hasDashboard: false,
    dashboardData: {},
    status: LoadingStatus.IDLE,
} as DashboardState

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        enableDashboard: (state: DashboardState) => {
            state.hasDashboard = true
        },
        disableDashboard: (state: DashboardState) => {
            state.hasDashboard = false
        },
    },
    extraReducers(builder) {
        builder
            .addCase(loadStats.pending, (state: DashboardState, action) => {
                state.activeRequestId = action.meta.requestId
                state.status = LoadingStatus.LOADING
            })
            .addCase(loadStats.fulfilled, (state: DashboardState, action) => {
                if (state.activeRequestId !== action.meta.requestId) return

                const { payload } = action

                delete state.activeRequestId
                state.status = LoadingStatus.LOADED

                state.dashboardData = ParseDashboard(payload)

                state.hasDashboard = true
            })
            .addCase(loadStats.rejected, (state: DashboardState, action) => {
                if (state.activeRequestId !== action.meta.requestId) return

                delete state.activeRequestId
                state.status = LoadingStatus.FAILED
                state.hasDashboard = false
            })

            // Reset state when user logs out.
            .addCase(sessionEnded, (state: DashboardState) => {
                delete state.activeRequestId
                state.status = LoadingStatus.IDLE
                state.dashboardData = {} as DashboardData
                state.hasDashboard = false
            })
    },
})

export default dashboardSlice
